import React, { useContext, useEffect, useRef, useState } from "react"
import Header from "../Global/Header"
import PageContent from "../Global/PageContent"
import { Link, useNavigate } from "react-router-dom"
import Timeline from "../Global/Timeline"
import { FiArrowRight, FiChevronDown, FiEdit, FiSearch } from "react-icons/fi"
import { FaWhatsapp, FaPhoneAlt } from "react-icons/fa"
import Popup from "../Global/Popup/"
import removerAcentos from "../../inc/Fx/removerAcentos"
import toggleRef from "../../inc/Fx/toggleRef"
import api from "../../services/api"
import updateLead from "../../inc/Fx/updateLead"
import dateISO8601 from "../../inc/Fx/dateISO8601"
import axios from "axios"
import { GlobalContext } from "../../contexts/global"
import encryptClass from "../../inc/Controllers/encrypt.class"
import TabelaConsultas from "../../components/TabelaConsultas"
import { dateDiff } from "../../inc/Fx/dateDiff"
import { formatDateBR } from "../../inc/Fx/formatDateTime"
import Alert from "../Global/Alert"
import EncaminhamentoUpload from "../../components/EncaminhamentoUpload"
import "./style.css"

export default function Especialidade() {
  const [popup_especialidade, toggle_popup_especialidade] = useState(false)
  const [especialidade, set_especialidade] = useState("Escolha sua consulta")

  const [alertPediatria, setAlertPediatria] = useState(false)
  const [alertGeriatria, setAlertGeriatria] = useState(false)
  const [alertNeuropediatria, setAlertNeuropediatria] = useState(false)

  const [alertNutricao, setAlertNutricao] = useState(false)
  const [alertPsicologia, setAlertPsicologia] = useState(false)
  const [alertPreNatal, setAlertPreNatal] = useState(false)
  const [hasConvenio, setHasConvenio] = useState(false)
  const [isParticular, setIsParticular] = useState(false)

  const [nutricaoConfirmed, setNutricaoConfirmed] = useState(false)
  const [psicologiaConfirmed, setPsicologiaConfirmed] = useState(false)

  const [isPsicologiaChecked, setIsPsicologiaChecked] = useState(false)
  const [isNutricaoChecked, setIsNutricaoChecked] = useState(false)
  const [encaminhamentoUrl, setEncaminhamentoUrl] = useState(null)
  const [isAlertPreNatalChecked, setIsAlertPreNatalChecked] = useState(false)
  const [isAlertPreNatalConfirmed, setIsAlertPreNatalConfirmed] = useState(false)

  const [isOpen, onClose] = useState(false)
  const [agendamentosCanceladosProfissional, setAgendamentosCanceladosProfissional] = useState([])
  const [agendamentos, setAgendamentos] = useState([])
  const [retornos, setRetornos] = useState([])
  const [alertRetornoElegivel, setAlertRetornoElegivel] = useState(false)
  const [retornoElegivelData, setRetornoElegivelData] = useState(null)
  const continuarAgendamentoRef = useRef(null)

  const [idade, set_idade] = useState(0)
  const [is_responsavel, toggle_responsavel] = useState(false)
  const [nome_paciente, set_nome_paciente] = useState("")

  const [is_popup_submit_disabled, disable_popup_submit] = useState(true)
  const [is_body_submit_disabled, disable_body_submit] = useState(true)
  const navigate = useNavigate()
  const [isInputFilled, setInputFilled] = useState(false)
  const { setLoaderState, statusSegmais, patientFound } = useContext(GlobalContext)

  const { nasc, nome, id } = JSON.parse(encryptClass.reveal(patientFound))

  //Alerta de Erro
  const [alertError, setAlertError] = useState(false)
  //Alerta de sem horários disponíveis (Feegow responde success:false sem agenda)
  const [alertSemHorarios, setAlertSemHorarios] = useState(false)

  const search_handle = (text) => {
    toggleRef({
      querySelector: "especialidade",
      text: removerAcentos(text)
    })
  }

  let htmlEspecialidades = []
  const [especialidadesData, setEspecialidadesData] = useState()
  const [especialidades, setEspecialidades] = useState([])

  useEffect(() => {
    setLoaderState(true)
    const indexEspecialidades = async () => {
      let isSegMais = sessionStorage.getItem("statusSegmais") !== null
      let isConvenio = sessionStorage.getItem("convenio")

      if (isConvenio !== null) {
        const convenioSplit = isConvenio.split("::")
        if (convenioSplit.length > 1) {
          const convenio = convenioSplit[1]

          setHasConvenio(true)
          if (convenio.toLowerCase() === "true") {
            setIsParticular(true)
          }
        }
      }

      set_idade(dateDiff(nasc))
      set_nome_paciente(nome)

      await api
        .post("/procedures", {
          segmais: isSegMais,
          ...(!isSegMais && isConvenio
            ? { insurance: parseInt(isConvenio.split("::")[1]) }
            : {})
        })
        .then(async (feegowResp) => {
          const { success, content } = feegowResp.data
          if (success) {
            setEspecialidadesData(content)
          } else {
            setEspecialidadesData(false)
            return "Não foi possível buscar o serviço. Tente novamente mais tarde"
          }
        })
        .catch(() => {
          setLoaderState(false)
          setEspecialidadesData(false)
          return "Não foi possível buscar o serviço. Tente novamente mais tarde"
        })
    }

    api.get("/schedule", {
      params: {
        pacienteId: id
      }
    })
      .then(res => {
        const agendamentosFiltrados = res.data.content.filter(item => [1, 7].includes(item.status_id))
        setAgendamentos(agendamentosFiltrados)

        const canceladosProfissional = res.data.content.filter(item => item.status_id === 22)
        if (canceladosProfissional.length > 0) {
          setAgendamentosCanceladosProfissional(canceladosProfissional)
        }
      })
      .catch(() => {})

    api.get("/retorno/elegiveis", { params: { pacienteId: id } })
      .then(res => {
        const agendamentos = res.data && res.data.content && res.data.content.agendamentos
        setRetornos(agendamentos || [])
      })
      .catch(() => {})

    indexEspecialidades()
  }, [])

  useEffect(() => {
    async function callEspecialidadesData() {
      if (especialidadesData !== undefined) {
        await api.get("/procedures").then((resp) => {
          const { content } = resp.data

          let procedimentos = []

          const isClientParticular = sessionStorage.getItem("convenio") === 'true'; // Particular
          const isClientSegmais = sessionStorage.getItem("statusSegmais") !== null; // Segmais

          Object.keys(especialidadesData).forEach((index) => {
            let current = especialidadesData[index]

            Object.keys(content).forEach((index2) => {
              if (current.procedimento_id === content[index2].procedimento_id) {
                const procedimentoId = content[index2].procedimento_id

                if (isClientParticular || isClientSegmais) {
                  if (procedimentoId === 101103) return
                }

                procedimentos.push({
                  ...content[index2],
                  especialidade_id: current.especialidade_id[0]
                })
              }
            })
          })

          // Sorting
          let sorting = {}
          Object.keys(procedimentos).forEach((index) => {
            sorting[procedimentos[index].procedimento_name] = {
              procedimento_id: procedimentos[index].procedimento_id,
              especialidade_id: procedimentos[index].especialidade_id
            }
          })

          let sorted = Object.keys(sorting)
            .sort()
            .reduce((obj, key) => {
              obj[key] = sorting[key]
              return obj
            }, {})

          Object.keys(sorted).forEach((index) => {
            htmlEspecialidades.push(
              <div
                key={sorted[index].procedimento_id}
                className="input-radio-capsule list_content"
                especialidade={removerAcentos(index)}
              >
                <label>
                  <input
                    type="radio"
                    name="input-especialidade"
                    value={`${index}::${sorted[index].procedimento_id}::${sorted[index].especialidade_id}`}

                    onChange={(e) => {
                      const value = e.target.value
                      disable_popup_submit(true);

                      const nomeEspecialidade = value.split("::")[0];
                      const procedimento = procedimentos.find(p => p.procedimento_id === parseInt(value.split("::")[1]))
                      const exist = agendamentos.find(item => item.procedimento_id === parseInt(value.split("::")[1]))
                      const convenio = sessionStorage.getItem("convenio")
                      const statusSegmais = sessionStorage.getItem("statusSegmais")
                      if (exist) {
                        onClose(true)
                        disable_popup_submit(true)
                        set_especialidade("Escolha sua consulta")
                      } else {
                        set_especialidade(value)

                         const procedimentoId = parseInt(value.split("::")[1])
                         const retornoElegivelLocal = retornos.find(function(r) {
                           return r.procedimento_id === procedimentoId &&
                             new Date() <= new Date(r.data_limite_retorno)
                         })
                         if (retornoElegivelLocal) {
                           setRetornoElegivelData({
                             agendamento: retornoElegivelLocal,
                             data_limite_retorno: retornoElegivelLocal.data_limite_retorno
                           })
                           setAlertRetornoElegivel(true)
                           disable_popup_submit(true)
                         }
                         if (retornoElegivelLocal) {
                           continuarAgendamentoRef.current = () => {
                             disable_popup_submit(false)
                             disable_body_submit(false)
                             if (value.includes("Pediatria") && idade >= 14) {
                               setAlertPediatria(true)
                               disable_body_submit(true)
                             } else if (value.includes("Nutrição") && hasConvenio && !isParticular) {
                               setAlertNutricao(true)
                               disable_body_submit(true)
                             } else if (value.includes("Psicologia") && hasConvenio && !isParticular) {
                               setAlertPsicologia(true)
                               disable_body_submit(true)
                             } else if (value.includes("Pré-natal") && idade < 18) {
                               setAlertPreNatal(true)
                               disable_body_submit(true)
                             } else if (value.includes("Geriatria") && idade < 60) {
                               setAlertGeriatria(true)
                               disable_body_submit(true)
                             } else if (value.includes("Neuropediatria") && idade > 13) {
                               setAlertNeuropediatria(true)
                               disable_body_submit(true)
                             } else {
                               toggle_popup_especialidade(false)
                             }
                           }
                           return
                         }

                        disable_popup_submit(false)
                        disable_body_submit(false)
                        if (value.includes("Pediatria") && idade >= 14) {
                          setAlertPediatria(true)
                          disable_body_submit(true)
                        } else if (value.includes("Nutrição") && hasConvenio && !isParticular) {
                          setAlertNutricao(true)
                          disable_body_submit(true)
                        } else if (value.includes("Psicologia") && hasConvenio && !isParticular) {
                          setAlertPsicologia(true)
                          disable_body_submit(true)
                        } else if (value.includes("Pré-natal") && idade < 18) {
                          setAlertPreNatal(true)
                          disable_body_submit(true)
                        } else if (value.includes("Geriatria") && idade < 60) {
                          setAlertGeriatria(true)
                          disable_body_submit(true)
                        } else if (value.includes("Neuropediatria") && idade > 13) {
                          setAlertNeuropediatria(true)
                          disable_body_submit(true)
                        } else {
                          toggle_popup_especialidade(false)
                        }
                      }
                    }}
                  />
                  <div className="icon">
                    <span></span>
                  </div>
                  <div className="label">{index}</div>
                </label>
              </div>
            )
          })

          setEspecialidades(htmlEspecialidades)
          setLoaderState(false)
        })
      }
    }

    callEspecialidadesData()
  }, [especialidadesData, agendamentos])

  function open_popup(e) {
    e.preventDefault()
    toggle_popup_especialidade(true)
  }
  const handle_submit = async (e) => {
    e.preventDefault()
    setLoaderState(true)

    updateLead({
      FEEGOW_ESPECIALIDADE: especialidade.split("::")[0],
      PACIENTE_IDADE: idade,
      PACIENTE_RESPONSAVEL: is_responsavel,
      PACIENTE_NOME: nome_paciente
    })

    let obs = `paciente: ${nome_paciente}\nidade: ${idade} \n #agWebConsultas`
    const requerEncaminhamento =
      ["Nutrição::262::22", "Psicologia::9603::60"].includes(especialidade) &&
      hasConvenio &&
      !isParticular
    const encaminhamento = encaminhamentoUrl || sessionStorage.getItem("encaminhamentoUrl")
    if (requerEncaminhamento && encaminhamento) {
      obs += `\n--- ENCAMINHAMENTO ---\n${encaminhamento}`
    } else {
      sessionStorage.removeItem("encaminhamentoUrl")
    }
    sessionStorage.setItem("obs", obs)
    sessionStorage.setItem("especialidade", especialidade)
    sessionStorage.removeItem("localId")
    sessionStorage.removeItem("slotUnidadeId")
    sessionStorage.removeItem("unidade")
    sessionStorage.removeItem("horario")
    sessionStorage.removeItem("medico")
    sessionStorage.removeItem("date_selected")

    const convenio = sessionStorage.getItem("convenio")
    const plano = sessionStorage.getItem("plano")

    const apiArgs = {
      procedimentoId: parseInt(especialidade.split("::")[1]),
      startDate: dateISO8601(true),
      endDate: dateISO8601(true, 45)
    }

    if (convenio && convenio.includes("::")) {
      const convenioId = parseInt(convenio.split("::")[1])
      if (!isNaN(convenioId)) {
        apiArgs.convenioId = convenioId
      }
    }

    if (plano && plano.includes("::")) {
      const planoId = parseInt(plano.split("::")[1])
      if (!isNaN(planoId)) {
        apiArgs.planoId = planoId
      }
    }

    await api
      .post("/schedule", apiArgs)
      .then((resp) => {
        const { success, content, professionals, units } = resp.data
        // Feegow sem agenda: responde success:false ("Não foi possível localizar horários").
        // Não é instabilidade — mostra o alerta específico de sem horários.
        if (success === false) {
          setLoaderState(false)
          setAlertSemHorarios(true)
          return
        }
        sessionStorage.setItem("schedule", JSON.stringify(content))
        sessionStorage.setItem("units", JSON.stringify(units))
        sessionStorage.setItem("professionals", JSON.stringify(professionals))
        setLoaderState(false)
        navigate("/unidade")
      })
      .catch((error) => {
        if (axios.isAxiosError(error)) {
          setLoaderState(false)
          const data = error.response && error.response.data
          if (data && data.err === "feegow") {
            setAlertSemHorarios(true)
          } else {
            setAlertError(true)
          }
        }
      })
  }

  //alertas de condições para especialidades
  const especialidadeConditions = {
    "Pediatria::245::6": { alert: setAlertPediatria, condition: () => true },
    "Nutrição::262::22": { alert: setAlertNutricao, condition: () => hasConvenio && !isParticular },
    "Psicologia::9603::60": { alert: setAlertPsicologia, condition: () => hasConvenio && !isParticular },
    "Pré-natal::100229::21": { alert: setAlertPreNatal, condition: () => isAlertPreNatalChecked && idade < 18 },
    "Geriatria::268::14": { alert: setAlertGeriatria, condition: () => true },
    "Neuropediatria::9585::58": { alert: setAlertNeuropediatria, condition: () => true }
  }

  const handle_popup_especialidade_submit = (e) => {
    e.preventDefault()
    let bodySubmit = false
    setInputFilled(true)

    if (especialidadeConditions[especialidade] && especialidadeConditions[especialidade].condition()) {
      especialidadeConditions[especialidade].alert(true)
      bodySubmit = true
    }
    disable_body_submit(bodySubmit)
    if (!bodySubmit) {
      toggle_popup_especialidade(false)
    }
  }

  const handle_alert_prenatal = (e) => {
    e.preventDefault()
    setAlertPreNatal(false)
    setIsAlertPreNatalConfirmed(true)
    disable_body_submit(false)
    toggle_popup_especialidade(false)
    updateLead({ VALID_POPUP: true })
  }

  /*const handle_alert_nutricao = (e) => {
    e.preventDefault()
    setAlertNutricao(false)
    setNutricaoConfirmed(true)
    disable_body_submit(false)
    toggle_popup_especialidade(false)
    updateLead({ VALID_POPUP: true })
  }
    */

  // Encaminhamento enviado: guarda o link, libera o avanço do fluxo e fecha o alerta/popup.
  const handle_encaminhamento_uploaded = (setAlert) => (url) => {
    setEncaminhamentoUrl(url)
    setAlert(false)
    disable_body_submit(false)
    toggle_popup_especialidade(false)
    updateLead({ VALID_POPUP: true })
  }

/*
    const handle_alert_psicologia = (e) => {
    e.preventDefault()
    setAlertPsicologia(false)
    setPsicologiaConfirmed(true)
    disable_body_submit(false)
    toggle_popup_especialidade(false)
    updateLead({ VALID_POPUP: true })
  }
    */

  const handle_outro_cpf = () =>{
    setAlertPediatria(false)
    localStorage.setItem("showPopupOnReturn", "true")
    navigate("/")
    updateLead({ VALID_POPUP: true })
  }
  const handle_outra_especialidade = () => {
    setAlertPediatria(false)
    setAlertGeriatria(false)
    setAlertNeuropediatria(false)
    updateLead({ VALID_POPUP: true })
  }

  const mainClassName = statusSegmais ? "page-segmais" : ""
  return (
    <>
      <main className={`site-main page-especialidade ${mainClassName}`}>
        <Header back_to="/cadastro">
          <h1>Atenção</h1>
        </Header>
        <PageContent>
          <Timeline step={1} />
          {/* Fluxo 1 — Retorno elegível para o procedimento selecionado */}
          <Alert
            isOpen={alertRetornoElegivel}
            onClose={() => { setAlertRetornoElegivel(false); disable_popup_submit(false) }}
            title="Retorno disponível!"
            showOkButton={false}
          >
            {retornoElegivelData && retornoElegivelData.agendamento && (
              <>
                <p>Identificamos que você tem um retorno disponível para esta consulta:</p>
                <p><strong>{retornoElegivelData.agendamento.procedimento_nome}</strong> com <strong>{retornoElegivelData.agendamento.profissional_nome}</strong></p>
                <p>Realizada em {formatDateBR(retornoElegivelData.agendamento.data_hora)} — válido até {formatDateBR(retornoElegivelData.data_limite_retorno)}</p>
                <div className="alerta-acoes">
                  <button onClick={() => {
                    const ag = retornoElegivelData.agendamento
                    const saudacao = nome_paciente ? "Olá! Me chamo *" + nome_paciente + "* e gostaria" : "Olá! Gostaria"
                    const msg = saudacao + " de agendar um retorno para a consulta de *" + ag.procedimento_nome + "* com *" + ag.profissional_nome + "* realizada em *" + formatDateBR(ag.data_hora) + "* na unidade *" + ag.unidade_nome + "*. Meu retorno é válido até *" + formatDateBR(retornoElegivelData.data_limite_retorno) + "*."
                    window.open("https://wa.me/552126665800?text=" + encodeURIComponent(msg), '_blank')
                    setAlertRetornoElegivel(false)
                  }}>Agendar retorno</button>
                  <button onClick={() => {
                    setAlertRetornoElegivel(false)
                    if (continuarAgendamentoRef.current) {
                      continuarAgendamentoRef.current()
                      continuarAgendamentoRef.current = null
                    }
                  }}>Continuar agendamento</button>
                </div>
              </>
            )}
          </Alert>

          {/* Alerta de Erro */}
          <Alert
            isOpen={alertError}
            onClose={() => setAlertError(false)}
            title={"Desculpe"}
            showOkButton={false}
          >


            <p>Estamos com instabilidade no sistema.<br />
              Por favor entre em contato com o nosso time pelo número:
            </p>
            <div className="contato-opcoes">
              <a className="contato-botao" href="tel:+552126665800">
                <FaPhoneAlt aria-hidden="true" />
                <span>Ligar (21) 2666-5800</span>
              </a>
            </div>

          </Alert>

          {/* Alerta de sem horários disponíveis */}
          <Alert
            isOpen={alertSemHorarios}
            onClose={() => setAlertSemHorarios(false)}
            title={"Agenda indisponível"}
            showOkButton={false}
          >
            <p>No momento não encontramos horários disponíveis para esta
              especialidade nos próximos dias.<br />
              Tente novamente mais tarde ou fale com o nosso time:
            </p>
            <div className="contato-opcoes">
              <a className="contato-botao" href="tel:+552126665800">
                <FaPhoneAlt aria-hidden="true" />
                <span>Ligar (21) 2666-5800</span>
              </a>
              <a
                className="contato-botao contato-botao--whatsapp"
                href={`https://wa.me/552126665808?text=${encodeURIComponent("Olá! Não encontrei horários disponíveis no Agendamento Online e preciso de ajuda para agendar minha consulta.")}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaWhatsapp aria-hidden="true" />
                <span>WhatsApp (21) 2666-5808</span>
              </a>
            </div>
          </Alert>

          {/*Alerta de agendamento Duplicado*/}
          <Alert isOpen={isOpen} onClose={onClose} title="Alerta">
            <p>Você já possui um Agendamento para esta consulta.</p>
          </Alert>

          {/*Alerta de agendamento(s) cancelado(s) pelo profissional*/}
          <Alert
            isOpen={agendamentosCanceladosProfissional.length > 0}
            onClose={() => setAgendamentosCanceladosProfissional([])}
            title="Alerta"
            wide
          >
            <p>
              {agendamentosCanceladosProfissional.length > 1
                ? "Identificamos que você possui os seguintes agendamentos cancelados por indisponibilidade do profissional. Em breve entraremos em contato para reagendar:"
                : "Identificamos que você possui um agendamento cancelado por indisponibilidade do profissional. Em breve entraremos em contato para reagendar."}
            </p>

            {/* DESKTOP/TABLET: tabela */}
            <div className="table-container show-desktop">
              <div className="table-wrapper">
                <table className="custom-table cancelados-table">
                  <thead>
                    <tr>
                      <th className="table-header align-center">Procedimento</th>
                      <th className="table-header align-center">Data</th>
                      <th className="table-header align-center">Horário</th>
                    </tr>
                  </thead>
                  <tbody>
                    {agendamentosCanceladosProfissional.map(item => (
                      <tr key={item.agendamento_id} className="table-row">
                        <td className="table-cell primary align-center">{item.procedimento_name}</td>
                        <td className="table-cell primary align-center">{formatDateBR(item.data)}</td>
                        <td className="table-cell primary align-center">{item.horario && item.horario.slice(0, 5)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* MOBILE: cards empilhados, sem scroll horizontal */}
            <div className="cards-container show-mobile">
              {agendamentosCanceladosProfissional.map(item => (
                <article key={item.agendamento_id} className="consulta-card cancelados-card" aria-label="Agendamento cancelado pelo profissional">
                  <div className="kv">
                    <span className="kv-label">Procedimento</span>
                    <span className="kv-value">{item.procedimento_name}</span>
                  </div>
                  <div className="kv">
                    <span className="kv-label">Data</span>
                    <span className="kv-value">{formatDateBR(item.data)}</span>
                  </div>
                  <div className="kv">
                    <span className="kv-label">Horário</span>
                    <span className="kv-value">{item.horario && item.horario.slice(0, 5)}</span>
                  </div>
                </article>
              ))}
            </div>
          </Alert>

{/*Alerta Nutrição*/}

          <Alert
            isOpen={alertNutricao}
            onClose={() => setAlertNutricao(false)}
            title="Atenção!"
            disabled={!isNutricaoChecked}
            showOkButton={false}
          >
            <p>Para realizar o atendimento com nutricionista, é necessário enviar o encaminhamento médico para autorização junto a seu convênio.</p>
            <div className="alert-especialidade">
              <label>
                <input
                  type="checkbox"
                  checked={isNutricaoChecked}
                  onChange={(e) => setIsNutricaoChecked(e.target.checked)}
                />
                <p> Estou ciente do encaminhamento do pedido. </p>
              </label>
              {isNutricaoChecked && (
                <EncaminhamentoUpload
                  clientCPF={sessionStorage.getItem("client_cpf")}
                  onUploaded={handle_encaminhamento_uploaded(setAlertNutricao)}
                />
              )}
            </div>
          </Alert>

{/*Alerta Psicologia*/}

          <Alert
            isOpen={alertPsicologia}
            onClose={() => setAlertPsicologia(false)}
            title="Atenção!"
            disabled={!isPsicologiaChecked}
            showOkButton={false}
          >
            <p>Para realizar o atendimento com psicólogo, é necessário enviar o encaminhamento médico para autorização junto a seu convênio.</p>
            <div className="alert-especialidade">
              <label>
                <input
                  type="checkbox"
                  checked={isPsicologiaChecked}
                  onChange={(e) => setIsPsicologiaChecked(e.target.checked)}
                />
                <p> Estou ciente do encaminhamento do pedido. </p>
              </label>
              {isPsicologiaChecked && (
                <EncaminhamentoUpload
                  clientCPF={sessionStorage.getItem("client_cpf")}
                  onUploaded={handle_encaminhamento_uploaded(setAlertPsicologia)}
                />
              )}
            </div>
          </Alert>

          {/*Alerta Pre-Natal*/}
          <Alert
            isOpen={alertPreNatal}
            onClose={() => setAlertPreNatal(false)}
            title="Atenção!"
            disabled={!isAlertPreNatalChecked}
            showOkButton={false}
          >
            <p>Em casos de atendimento para pacientes menores de idade, é necessário estar acompanhado de um representante legal.</p>
            <div className="alert-especialidade">
              <label>
                <input
                  type="checkbox"
                  checked={isAlertPreNatalChecked}
                  onChange={(e) => setIsAlertPreNatalChecked(e.target.checked)}
                />
                <p>Estou ciente dessa obrigatoriedade.</p>
              </label>
              <div className="alerta-acoes">
                <button onClick={handle_alert_prenatal} disabled={!isAlertPreNatalChecked}>
                  Ok
                </button>
              </div>
            </div>
          </Alert>

          {/*Alerta Pediatria*/}
          <Alert
            isOpen={alertPediatria}
            onClose={() => setAlertPediatria(false)}
            title="Atenção!"
            showOkButton={false}
          >
            <p>Não é possível agendar consultas de Pediatria para pacientes com mais de 13 anos.</p>
            <p>Por favor escolha uma das opções abaixo.</p>
            <div className="alerta-acoes">
              <button onClick={handle_outro_cpf}>Outro CPF</button>
              <button onClick={handle_outra_especialidade} >Outra especialidade</button>
            </div>
          </Alert>

          {/*Alerta Geriatria*/}
          <Alert
            isOpen={alertGeriatria}
            onClose={() => setAlertGeriatria(false)}
            title="Atenção!"
            showOkButton={false}
          >
            <p>Não é possível agendar consultas de Geriatria para pacientes abaixo de 60 anos.</p>
            <p>Por favor escolha uma das opções abaixo.</p>
            <div className="alerta-acoes">
              <button onClick={handle_outro_cpf}>Outro CPF</button>
              <button onClick={handle_outra_especialidade} >Outra especialidade</button>
            </div>
          </Alert>

          {/*Alerta Neuropediatria*/}
          <Alert
            isOpen={alertNeuropediatria}
            onClose={() => setAlertNeuropediatria(false)}
            title="Atenção!"
            showOkButton={false}
          >
            <p>Não é possível agendar consultas de Neuropediatria para pacientes com mais de 13 anos.</p>
            <p>Por favor escolha uma das opções abaixo.</p>
            <div className="alerta-acoes">
              <button onClick={handle_outro_cpf}>Outro CPF</button>
              <button onClick={handle_outra_especialidade} >Outra especialidade</button>
            </div>
          </Alert>

          {/* Renderiza todas as Especialidades */}
          <Popup
            ID="especialidade"
            open={popup_especialidade}
            handle={toggle_popup_especialidade}
          >
            <form onSubmit={handle_popup_especialidade_submit}>
              <div
                className="input-text input-search "
                style={{ marginBottom: "1.75rem" }}
              >
                <label htmlFor="search-especialidade" style={{ marginTop: "2rem" }}>
                  <input
                    type="text"
                    name="search-especialidade"
                    id="search-especialidade"
                    onKeyUp={(e) => search_handle(e.target.value)}
                    placeholder="Buscar consulta"
                  />
                  <FiSearch />
                </label>
              </div>
              <div>
                {especialidades}
              </div>
            </form>
          </Popup>

          <form onSubmit={handle_submit}>
            <Link
              className={`selector-format ${isInputFilled ? "filled" : ""}`}
              onClick={(e) => open_popup(e)}
            >
              <span>
                {especialidade.split("::")[0]}
                <FiEdit size={8} />
              </span>
              <FiChevronDown />
            </Link>

            <TabelaConsultas
              agendamentos={agendamentos}
              retornos={retornos}
              pacienteNome={nome_paciente}
              pacienteCpf={sessionStorage.getItem("client_cpf")}
            />


            <div className="returnExame">
              {/* aviso de consulta */}

              <div className="link-wrapper">
                <div className="text">
                  <h2 className="titleBox">Olá, {nome.split(" ")[0]}</h2>
                  <h4>
                    {" "}
                    <p>Informamos que para agendar <strong>Revisão de Consulta</strong></p>
                  </h4>

                  {/* ref 2 */}

                  <div className="callTel">
                    <a
                      href={`https://wa.me/552126665800?text=Olá, quero agendar consulta!`}
                      onClick={() => {
                        updateLead({
                          UI_NOT_FOUND_DATE: 1
                        })
                      }}
                    >
                      <p> Entre em contato pelo whatsapp: (21) 2666-5800.</p>
                    </a>
                    <img className="icoTel" src="./whatsapp-line.svg" />
                  </div>
                </div>
              </div>
            </div>


            <div className={`input-submit ${is_body_submit_disabled && !nutricaoConfirmed && !isAlertPreNatalConfirmed ? "disabled" : ""}`}>
              <button type="submit">
                Prosseguir
                <FiArrowRight />
              </button>
            </div>
          </form>
        </PageContent>
      </main>
    </>
  )
}
